module.exports = __webpack_public_path__ + "static/media/scglab-logo-footer-B.9be5dc54.svg";